import { PanelsActions } from "./side_panel_store.types";
import { useSidePanelsStore } from "./use_side_panels_store";

export const useSidePanelsActions = <T extends object>(): PanelsActions<T> =>
  useSidePanelsStore((state) => state.actions);
